import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { VerificationService, getFaqLink } from '@sheerid/jslib';

interface Props {
    verificationService: VerificationService;
}

const FaqLinkComponent: React.SFC<Props> = ({ verificationService }) => {
    const { segment } = verificationService.verificationResponse;
    const { programId, programTheme } = verificationService;

    if (segment) {
        const faqHref = getFaqLink(programTheme, segment, programId);

        return (
            <a
                className="sid-faq sid-link"
                tabIndex={0}
                href={faqHref}
                target="_blank"
                rel="noopener noreferrer">
                <FormattedHTMLMessage id="sheeridFaqs" defaultMessage="SheerID FAQs" />
            </a>
        );
    }
    return null;
};

export { FaqLinkComponent };
